module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.fa7e6e7d.ttf";